export const focusShadow = (color: string) => `0 0 0 3px ${color}`;
